import React from "react";
import styled from 'styled-components';
import magnifying from '../../../img/svg/magnifying-glass.svg';
import MaskedInput from 'react-text-mask';
import filter from '../../../img/svg/ico-filter.svg';

export const ContainerInput = styled.div`
  width: 17vw;

  &:after {
    content: url(${magnifying});
    width: .5rem;
    height: .5rem;
    position: absolute;
    left: 60%;
  }
`;

export const Input = styled.input`
  width: 100%;
  outline-width: 0;
  font-size: .9rem;
  font-family: 'Open Sans';
  background: transparent;
  border: transparent;
  border-bottom: 1px solid ${props => props.theme['color_border-gray-secondary']};
  padding-left: 8px;
  color: ${props => props.theme.color_gray};

  &:focus {
    background: ${props => props.theme.color_white};
  }
`;

export const DateInput = styled(MaskedInput)`
  width: 100%;
  outline-width: 0;
  font-size: .8rem;
  font-family: 'Open Sans';
  background: transparent;
  border: transparent;
  border-bottom: 1px solid ${props => props.theme['color_border-gray-secondary']};
  padding-left: 8px;
  color: ${props => props.theme.color_gray};

  ::-webkit-input-placeholder { /* Chrome */
    color: ${props => props.theme["color_border-gray"]};
  }
  :-ms-input-placeholder { /* IE 10+ */
    color: ${props => props.theme["color_border-gray"]};
  }
  ::-moz-placeholder { /* Firefox 19+ */
    color: ${props => props.theme["color_border-gray"]};
    opacity: 1;
  }
  :-moz-placeholder { /* Firefox 4 - 18 */
    color: ${props => props.theme["color_border-gray"]};
    opacity: 1;
  }
`;

export const DateContainerInput = styled.div`
  width: 8vw;
  display: inline-block;
`;

export const FilterContainerInput = styled.div`
  width: 20vw;
  display: inline-block;
`;

export const FilterIcon = styled.img`
  height: .9rem;
`;

export const FilterInput = styled.input`
  width: 100%;
  outline-width: 0;
  font-size: .8rem;
  font-family: 'Open Sans';
  background: transparent;
  border: transparent;
  border-bottom: 1px solid ${props => props.theme['color_border-gray-secondary']};
  padding-left: 8px;
  color: ${props => props.theme.color_gray};

  &:focus {
    background: ${props => props.theme.color_white};
  }

  ::-webkit-input-placeholder { /* Chrome */
    color: ${props => props.theme["color_border-gray"]};
  }
  :-ms-input-placeholder { /* IE 10+ */
    color: ${props => props.theme["color_border-gray"]};
  }
  ::-moz-placeholder { /* Firefox 19+ */
    color: ${props => props.theme["color_border-gray"]};
    opacity: 1;
  }
  :-moz-placeholder { /* Firefox 4 - 18 */
    color: ${props => props.theme["color_border-gray"]};
    opacity: 1;
  }

`;

export const FilterButton = styled.button`
  cursor: pointer;
  padding: .25rem .5rem;
  margin-left: 10px;
  background-color: white;
  color: #152b4e;
  border: 1px solid #152b4e;
  transition: all 100ms ease-in;
  transform: scale(1.05);
  border-radius: 0;
  font: 500 .8rem 'Arial' ;
  line-height: 1;
  height: 20px;

  &:focus {
    outline: none;
  }
`

export const FilterText = styled.span`
  color: ${props => props.theme.color_gray};
  font-size: 12px;
  font-family: 'Open Sans';
`;